<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-09-05 10:00:52
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-10-27 17:45:26
 * @FilePath: \land_informatization\src\views\Map.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myMapBoxBody">
    <div class="getSbdDataPop" v-show="isShowgetSbdDataPop">
      <div class="closeIconBox" @click="isShowgetSbdDataPop = false">
        <i class="el-icon-close"></i>
      </div>
      <div class="getSbdDataPopTitle">地块信息</div>
      <div class="getsbdTextBox">地块编号：{{ chooseLandId }}</div>
      <div class="getsbdTextBox">行政区名称：{{form.desc}}</div>
      <div class="getsbdTextBox">土地状态：{{form.region}}</div>
      <div class="getsbdTextBox">
        土地面积：{{ areaDataText.toFixed(4) }}平方千米
      </div>
    </div>
    <div class="bufferDataChangeBox" v-show="isShowDeffer">
      <div class="bufferDataTitleBox">缓冲区距离</div>
      <div class="sildBox">
        <el-input
          style="width: 100px"
          type="number"
          v-model="bufferNum"
          size="mini"
          placeholder="请输入内容"
        ></el-input>
        <p>米</p>
      </div>
      <el-button
        style="margin-top: 15px"
        type="primary"
        size="mini"
        @click="getbufferData"
        >确定</el-button
      >
      <!-- <el-button style="margin-top:15px" type="primary" size="mini" @click="closeBufferBox">关闭</el-button> -->
    </div>
    <div class="bufferBox" @click="getbufferData">
      <img src="../assets/buffer.png" title="缓冲区计算" alt />
    </div>
    <div class="bufferBox2" @click="clipPy">
      <img src="../assets/cilp.png" title="裁剪" alt />
    </div>
    <div class="bufferBox3" @click="changeDelType">
      <img
        src="../assets/del.png"
        v-show="!isOpenDel"
        title="开启删除图形"
        alt
      />
      <img
        src="../assets/delactive.png"
        v-show="isOpenDel"
        title="关闭删除图形"
        alt
      />
    </div>
    <div class="bufferBox4" @click="getintersectPydata">
      <img
        src="../assets/uni.png"
        v-show="!isOpengetintersect"
        title="获取交集"
        alt
      />
      <img
        src="../assets/uniactive.png"
        v-show="isOpengetintersect"
        title="关闭获取交集"
        alt
      />
    </div>
    <div class="myMapbox" id="mymap"></div>
    <div class="showAreaBox">
      <div style="margin-bottom: 15px">选择模式</div>
      <el-switch
        v-model="chooseType"
        @change="chooseTypeChange"
        active-text="多选"
        inactive-text="单选"
      >
      </el-switch>
      <!-- <div class="areaDataBox">面积：{{ areaDataText.toFixed(4) }}km²</div> -->
    </div>
    <div class="chooseUseLayerbox">
      <div style="margin-bottom: 15px">触发模式</div>
      <el-radio-group v-model="layerCantouch" @change="typechange" size="mini">
        <el-radio-button label="guikong">控规图层</el-radio-button>
        <el-radio-button label="quanshu">权属图层</el-radio-button>
        <el-radio-button label="suipian">碎片图层</el-radio-button>
      </el-radio-group>
    </div>
    <div class="chooseUseLayerbox2">
      <div style="margin-bottom: 15px">展示图层</div>
      <el-checkbox-group v-model="checkedCLayer" @change="checkedCLayerChange">
        <el-checkbox :label="'控规图层'">控规图层</el-checkbox>
        <el-checkbox :label="'权属图层'">权属图层</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="chooseUseLayerbox3">
      <div style="margin-bottom: 15px">数据统计</div>
      <el-button type="primary" class="tongjiBtn" @click="showAreaPop"
        >统计</el-button
      >
    </div>
    <div
      class="chooseUseLayerbox4"
      v-show="!chooseType && layerCantouch != 'guikong'"
    >
      <div style="margin-bottom: 15px">编辑属性</div>
      <el-button type="primary" class="tongjiBtn" @click="showEditPopHandeller"
        >编辑</el-button
      >
    </div>
    <el-dialog title="属性编辑" :visible.sync="isShowEditPop" width="30%">
      <el-form :model="form">
        <el-form-item label="地块编号" :label-width="formLabelWidth">
          <el-input v-model="chooseLandId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="行政区域名称" :label-width="formLabelWidth">
          <el-input v-model="form.desc" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="土地状态" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="请选择活动区域">
            <el-option label="已处置" value="已处置"></el-option>
            <el-option label="已开发" value="已开发"></el-option>
            <el-option label="未开发" value="未开发"></el-option>
            <el-option label="无" value="无"></el-option>
            <el-option label="临时处置" value="临时处置"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowEditPop = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="isShowAreaPop" width="30%">
      <span
        >你选择了{{
          !chooseType ? "1" : landNum
        }}块地，选择多个地块的总面积是{{ areaDataText.toFixed(4) }}km²</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShowAreaPop = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- <div class="mytableBox" v-show='false'>
      <el-table :data="ptTableData" height="700" style="width: 100%">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="type" label="类型"></el-table-column>
        <el-table-column prop="geoJson" label="矢量数据" width="180">
          <template slot-scope="scope">
            <div class="textBox">{{scope.row.geoJson}}</div>
          </template>
        </el-table-column>

        <el-table-column prop="latlon" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="gotoPypostion(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="expBtnBox">
        <el-button type="primary" @click="downLoadData">导出数据</el-button>
        <div style="margin-top:15px">
                    <el-upload
                ref="upload"
                action="111111"
                :limit="1"
                :file-list="fileList"
                accept="shp"
                :http-request="fileChange"
                :auto-upload="true">
                <el-button slot="trigger" size="small" type="primary">导入shp文件</el-button>
              </el-upload>
        </div>

      
      </div>
    </div> -->
  </div>
</template>

<script>
import { MapCreate, legendColor } from "../map/mapImport";
import * as turf from "@turf/turf";
import geoUtil from "../map/clip.js";
import { uuid } from "vue-uuid";
import * as XLSX from "xlsx";
import * as shapefile from "shapefile";
import testData from "../map/data.json";
import areadata from "../map/2000.json";
import gsxarea from "../map/gsxarea.json";
import normal from "../map/ditu.js";
// import legendColor from "./legendColor.json";
// import legendVue from "@/page/legend.vue";
import mapimg from "../assets/map/mapExport.js";
// import * as turf from '@turf/turf'
// import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.min.js';
// import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
export default {
  data() {
    return {
      landNum:0,
      editPYlistData:[],
      chooseLandId: 1,
      isShowgetSbdDataPop: false,
      fileList: [],
      ptTableData: [],
      isClip: false,
      map: null,
      rectangleLayer: null,
      chooseLayerData: null,
      rectangleGeoJson: null,
      bufferNum: 5000,
      isShowDeffer: false,
      bufferLayer: null,
      lineLayer: null,
      newDarwLayer: null,
      isChoosePy: false,
      areaMarker: null,
      isDelpylyaer: false,
      isOpenDel: false,
      uniPyList: [],
      isOpengetintersect: false,
      mapLayerList: [],
      chooseLayerCode: "",
      chooseType: true,
      choosePyListData: [],
      areaDataText: 0,
      layerCantouch: "guikong",
      layerControl: null,
      showkongguilayer: null,
      showquanshuilayer: null,
      checkedCLayer: ["控规图层", "权属图层"],
      suipianLayer: null,
      isShowAreaPop: false,
      isShowEditPop: false,
      chosePrintData: [],
      form: {
        name: "20",
        region: "无",

        delivery: false,

        desc: "平安村三组",
      },
      formLabelWidth: "100px",
    };
  },
  beforeDestroy() {
    this.map.map.remove();
  },
  mounted() {
    this.map = new MapCreate();
    this.map.init("mymap");
    const vector = `<img class='my-layer-img' data-index='行政图' src='${mapimg.vector}' /> `;
    const satellitepoi = `<img class='my-layer-img' data-index='卫星图' src='${mapimg.satellitepoi}' /> `;
    const terrain = `<img class='my-layer-img' data-index='地形图' src='${mapimg.terrain}' /> `;

    const baseLayers = {
      [vector]: normal.Gaode,
      [satellitepoi]: normal.image,
      [terrain]: normal.terrain,
    };

    this.layerControl = L.control.layers(baseLayers).addTo(this.map.map);
    //地图切换控件 img设置
    this.layerControl.setPosition("topright");
    this.layerControl._baseLayersList.style.display = "flex";
    this.layerControl._baseLayersList
      .querySelectorAll("label")
      .forEach((item) => {
        item.style.position = "relative";
        item.style.marginLeft = "5px";
        item.querySelector("input").style.cssText =
          "position:absolute;top:0;z-index:1; ";
      });
    this.map.map.pm.setLang("zh");
    this.showGuiKongTomap();
    // console.log(areadata);
    // let colorListobj = {
    //   A6: "#9966CC",
    //   A2: "#FF7FCC",
    //   A1: "#FF7FCC",
    //   A22: " #CC9999",
    //   A41: " #66CCCC",
    //   C36: " #66FF99",
    //   B: " #FF0000 ",
    //   G2: " #00CC99 ",
    //   GE: " #00CC33 ",
    //   B2: " #FF0000 ",
    //   U9: " #0000CC ",
    //   G1: " #AEE0CF ",
    //   R21: " #E0AFCE   ",
    //   R22: " #E0AFCE   ",
    //   B12: " #D7D6AC   ",
    //   U: " #E0AFCE   ",
    //   U22: "#E0AFCE",
    // };
    // let indexid = 0;
    // let shpData = L.geoJSON(areadata, {
    //   style: function (feature) {
    //     // console.log(feature);
    //     let color = colorListobj[feature.properties.Layer];
    //     console.log(color);
    //     if (color == undefined) {
    //       if (feature.properties.Layer == 131) {
    //         console.log(21212);

    //         color = "#8EAFD6";
    //       } else {
    //         color = "#AEE0CF";
    //       }
    //     }
    //     return {
    //       color: color,
    //       weight: 2,
    //       fillColor: color,
    //       fillOpacity: 1,
    //     };
    //   },
    //   onEachFeature: (e, layer) => {
    //     indexid++;
    //     let color = colorListobj[e.properties.Layer];
    //     console.log(color);
    //     if (color == undefined) {
    //       if (e.properties.Layer == 131) {
    //         console.log(21212);

    //         color = "#8EAFD6";
    //       } else {
    //         color = "#AEE0CF";
    //       }
    //     }
    //     let laeyerId = "pylayer" + indexid;
    //     layer.on("click", (el) => {
    //       // console.log(laeyerId);
    //       // console.log(el);

    //       if (!t.isOpenDel) {
    //         t.isChoosePy = true;
    //         let isHave = false;
    //         isHave = t.choosePyListData.find(
    //           (element) => element.id == laeyerId
    //         );

    //         if (t.chooseType) {
    //           if (t.choosePyListData.length > 0) {
    //             let indexele = t.choosePyListData.indexOf(isHave);

    //             if (indexele > -1) {
    //               // 或者 >= 0
    //               t.choosePyListData.splice(indexele, 1);
    //             }
    //             console.log(isHave);

    //             if (isHave != undefined) {
    //               console.log("cunzai");
    //               t.chooseLayerData = layer;
    //               t.getPyAreaDatacel();
    //               isHave.layer.setStyle({
    //                 color: color,
    //                 weight: 2,
    //                 fillColor: color,
    //                 fillOpacity: 1,
    //               });
    //             } else {
    //               t.chooseLayerData = layer;
    //               t.getPyAreaDatasum();
    //             }
    //           } else {
    //             t.chooseLayerData = layer;
    //             t.getPyAreaDatasum();
    //           }
    //           if (t.chooseType && !isHave) {
    //             t.choosePyListData.push({
    //               id: laeyerId,
    //               layer: layer,
    //             });
    //           }
    //         } else {
    //           if (t.chooseLayerData != null && t.chooseType == false) {
    //             t.chooseLayerData.setStyle({
    //               color: color,
    //               weight: 2,
    //               fillColor: color,
    //               fillOpacity: 1,
    //             });
    //             t.chooseLayerData = null;
    //           }

    //           t.chooseLayerData = layer;
    //           t.getPyAreaData();
    //         }

    //         if (!isHave) {
    //           t.chooseLayerData.setStyle({
    //             color: "red",
    //             weight: 2,
    //             fillColor: "red",
    //             fillOpacity: 0.5,
    //           });
    //         }
    //       } else {
    //         t.map.map.removeLayer(layer);
    //       }

    //       // console.log(t.isClip);
    //     });
    //   },
    // }).addTo(this.map.map);
    // this.map.map.flyToBounds(shpData.getBounds());
    // //  console.log([...new Set(colorList)]);

    // layerControl.addOverlay(shpData, "控规图层");
    // // console.log(huaguo7);

    // let guishulayer = L.geoJSON(gsxarea, {
    //   style: {
    //     color: `#ff9300`,
    //     weight: 3,
    //     fillColor: "#ff9300",
    //     fillOpacity: 0,
    //   },
    //   interactive: false,
    //   onEachFeature: (e, layer) => {
    //     layer.on("click", (el) => {
    //       // console.log(el);
    //       t.chooseLayerData = layer;
    //       t.chooseLayerData.setStyle({
    //         color: "red",
    //         weight: 2,
    //         fillColor: "red",
    //         fillOpacity: 0.2,
    //       });
    //       t.getPyAreaData();
    //     });
    //   },
    // }).addTo(this.map.map);
    // layerControl.addOverlay(guishulayer, "权属图层");
    // L.Icon.Default.mergeOptions({
    //   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    //   iconUrl: require('leaflet/dist/images/marker-icon.png'),
    //   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    //   iconSize: [16, 26],      // 修改图标大小（默认是 [25, 41]）
    //   iconAnchor: [8, 26],     // 调整图标锚点（根据新尺寸居中）
    //   shadowSize: [26, 26],    // 修改阴影大小（默认是 [41, 41]）
    //   popupAnchor: [0, -26],   // 调整弹窗位置锚点
    //   tooltipAnchor: [0, 12],  // 调整提示信息位置锚点
    // })
    this.map.map.on("overlayadd", () => {
      console.log("baselayerchange");
      // t.typechange()
    });
    this.map.map.on("overlayremove", () => {
      console.log("baselayerchange");
      // t.typechange()
    });
    this.map.map.pm.addControls({
      position: "topleft",
      drawPolygon: true, // 绘制多边形
      drawMarker: true, //绘制标记点
      drawCircleMarker: false, //绘制圆形标记
      drawPolyline: true, //绘制线条
      drawRectangle: true, //绘制矩形
      drawCircle: true, //绘制圆圈
      editMode: true, //编辑多边形
      dragMode: true, //拖动多边形
      cutPolygon: false, // 添加一个按钮以删除多边形里面的部分内容
      removalMode: false, // 清除多边形
    });

    //  map.on("pm:drawstart", e => {
    //          console.log(e, "点击控件绘制时调用");
    //  });
    //  map.on("pm:drawend", e => {
    //          console.log(e, "禁止绘制");
    //  });

    // 监听创建图形

    let t = this;

    this.map.map.on("pm:cut", (e) => {
      console.log(e);
      let layerCode = uuid.v1();
      t.rectangleGeoJson = e.layer.toGeoJSON();
      let rectangleLayer = e.layer;

      if (t.isClip == false) {
        t.mapLayerList.push({
          code: layerCode,
          layer: e,
        });
        t.addTableData();
      }

      t.newDarwLayer = e.layer;

      if (e.shape != "Line") {
        rectangleLayer.on("click", (el) => {
          t.chooseLayerCode = layerCode;
          if (t.isOpengetintersect) {
            t.uniPyList.push(rectangleLayer);
          }
          if (!t.isOpenDel) {
            t.isChoosePy = true;

            if (t.chooseLayerData != null) {
              t.chooseLayerData.setStyle({
                color: "#0080FF",
              });
            }

            rectangleLayer.setStyle({
              color: "red",
            });
            t.chooseLayerData = rectangleLayer;
            console.log(t.isClip);
          } else {
            t.map.map.removeLayer(rectangleLayer);
          }
        });
        rectangleLayer.on("remove", () => {
          console.log("remove");
          t.removeTableData(layerCode);
        });
      } else {
        rectangleLayer.on("click", (el) => {
          if (t.isOpenDel) {
            t.map.map.removeLayer(rectangleLayer);
          }
        });
      }

      if (t.isClip) {
        try {
          console.log(
            this.chooseLayerData.toGeoJSON(),
            this.newDarwLayer.toGeoJSON()
          );
          let clippedPolygon = geoUtil.polygonClipByLine(
            this.chooseLayerData.toGeoJSON(),
            this.newDarwLayer.toGeoJSON()
          );
          console.log(clippedPolygon);
          this.showCliopLyer(clippedPolygon);
          // this.bufferLayer = L.geoJSON(clippedPolygon, {
          //   style: {
          //     color: "#0080FF",
          //     weight: 2,
          //     fillColor: "#0080FF",
          //     fillOpacity: 0.2
          //   },
          //   onEachFeature: (e, layer) => {

          //     layer.on("click", el => {

          //       t.isChoosePy = true;
          //       if (t.chooseLayerData != null) {
          //         t.chooseLayerData.setStyle({
          //           color: "#0080FF",
          //         weight: 2,
          //         fillColor: "#0080FF",
          //         fillOpacity: 0.2
          //         });
          //          t.chooseLayerData=null
          //       }

          //       t.chooseLayerData = layer;
          //       t.chooseLayerData.setStyle({
          //         color: "red",
          //         weight: 2,
          //         fillColor: "red",
          //         fillOpacity: 0.5
          //       });
          //        t.getPyAreaData();
          //       // console.log(t.isClip);
          //     });
          //   }
          // }).addTo(this.map.map);
          this.map.map.removeLayer(t.chooseLayerData);

          this.map.map.removeLayer(this.newDarwLayer);
          let newJsonList = this.mapLayerList;
          this.mapLayerList = newJsonList.filter(
            (el) => el.code != this.chooseLayerCode
          );
          this.addTableData();
          this.chooseLayerData = null;
          this.newDarwLayer = null;
          this.isChoosePy = false;
          this.isClip = false;
        } catch (err) {
          console.log(err);
          this.$message({
            message: err.message,
            type: "warning",
          });
          this.map.map.removeLayer(t.newDarwLayer);
          this.isClip = false;
        }
      }
    });
    this.map.map.on("pm:create", (e) => {
      // 记录当前绘制的图形
      // console.log(e);
      // console.log(uuid.v1());
      let layerCode = uuid.v1();
      t.rectangleGeoJson = e.layer.toGeoJSON();
      let rectangleLayer = e.layer;

      if (t.isClip == false) {
        t.mapLayerList.push({
          code: layerCode,
          layer: e,
        });
        t.addTableData();
      }

      t.newDarwLayer = e.layer;
      // this.lineLayer = e.layer

      // console.log( );

      if (e.shape != "Line") {
        rectangleLayer.on("click", (el) => {
          // console.log('created');
          t.chooseLayerCode = layerCode;
          if (t.isOpengetintersect) {
            t.uniPyList.push(rectangleLayer);
          }
          if (!t.isOpenDel) {
            t.isChoosePy = true;

            if (t.chooseLayerData != null) {
              t.chooseLayerData.setStyle({
                color: "#0080FF",
              });
            }

            rectangleLayer.setStyle({
              color: "red",
            });
            t.chooseLayerData = rectangleLayer;
            console.log(t.isClip);
            if (e.shape != "Circle") {
              t.getPyAreaData();
            } else {
              t.getCircleArea(e.layer._mRadius, e.layer._latlng);
            }
          } else {
            t.map.map.removeLayer(rectangleLayer);
          }
        });
        rectangleLayer.on("remove", () => {
          // console.log('remove');
          t.removeTableData(layerCode);
        });
      } else {
        rectangleLayer.on("click", (el) => {
          if (t.isOpenDel) {
            t.map.map.removeLayer(rectangleLayer);
          }
        });
      }

      if (t.isClip) {
        try {
          console.log(
            this.chooseLayerData.toGeoJSON(),
            this.newDarwLayer.toGeoJSON()
          );
          let clippedPolygon = geoUtil.polygonClipByLine(
            this.chooseLayerData.toGeoJSON(),
            this.newDarwLayer.toGeoJSON()
          );
          console.log(clippedPolygon);
          this.showCliopLyer(clippedPolygon);
          // this.bufferLayer = L.geoJSON(clippedPolygon, {
          //   style: {
          //     color: "#0080FF",
          //     weight: 2,
          //     fillColor: "#0080FF",
          //     fillOpacity: 0.2
          //   },
          //   onEachFeature: (e, layer) => {

          //     layer.on("click", el => {

          //       t.isChoosePy = true;
          //       if (t.chooseLayerData != null) {
          //         t.chooseLayerData.setStyle({
          //           color: "#0080FF",
          //         weight: 2,
          //         fillColor: "#0080FF",
          //         fillOpacity: 0.2
          //         });
          //          t.chooseLayerData=null
          //       }

          //       t.chooseLayerData = layer;
          //       t.chooseLayerData.setStyle({
          //         color: "red",
          //         weight: 2,
          //         fillColor: "red",
          //         fillOpacity: 0.5
          //       });
          //        t.getPyAreaData();
          //       // console.log(t.isClip);
          //     });
          //   }
          // }).addTo(this.map.map);
          this.map.map.removeLayer(t.chooseLayerData);

          this.map.map.removeLayer(this.newDarwLayer);
          let newJsonList = this.mapLayerList;
          this.mapLayerList = newJsonList.filter(
            (el) => el.code != this.chooseLayerCode
          );
          this.addTableData();
          this.chooseLayerData = null;
          this.newDarwLayer = null;
          this.isChoosePy = false;
          this.isClip = false;
        } catch (err) {
          console.log(err);
          this.$message({
            message: err.message,
            type: "warning",
          });
          this.map.map.removeLayer(t.newDarwLayer);
          this.isClip = false;
        }
      }
    });
  },
  methods: {
  openpopInfo(){
      let isHave = false;
              isHave = this.editPYlistData.find(
                (element) => element.id == this.chooseLandId
              );
              if(isHave!=undefined){
                let indexele = this.editPYlistData.indexOf(isHave);
                let haveData = this.editPYlistData[indexele]
                this.form.desc=haveData.desc
                this.form.region=haveData.region
                  
               
              }else{
                 this.form.desc='平安村三组'
                this.form.region='无'
              }
  },
    submitEdit(){
      // editPYlistData
       let isHave = false;
              isHave = this.editPYlistData.find(
                (element) => element.id == this.chooseLandId
              );
              if(isHave!=undefined){
                let indexele = this.editPYlistData.indexOf(isHave);

                  console.log(indexele);
                  this.editPYlistData[indexele]={
                  id:this.chooseLandId,
                  desc:this.form.desc,
                  region:this.form.region,
                }
              }else{
                this.editPYlistData.push({
                  id:this.chooseLandId,
                  desc:this.form.desc,
                  region:this.form.region,
                })
              }
              console.log(  this.editPYlistData);
              this.isShowEditPop = false;
    },
    showEditPopHandeller() {
       let isHave = false;
              isHave = this.editPYlistData.find(
                (element) => element.id == this.chooseLandId
              );
              if(isHave!=undefined){
                let indexele = this.editPYlistData.indexOf(isHave);
                let haveData = this.editPYlistData[indexele]
                this.form.desc=haveData.desc
                this.form.region=haveData.region
                  
               
              }else{
                 this.form.desc='平安村三组'
                this.form.region='无'
              }
      this.isShowEditPop = true;
    },
    showAreaPop() {
      if (this.chooseLayerData != null) {
        this.isShowAreaPop = true;
      } else {
        this.$message({
          message: "未选择地块，请选择地块",
          type: "warning",
        });
      }
    },
    getPyAreaDatasuipian() {
      let arrListData = [];
      let testData = this.chooseLayerData.toGeoJSON();
      // console.log(testData);

      // testData.map((item) => {
      //   arrListData.push([item.lng, item.lat]);
      // });

      // console.log(gsxarea.features.contains([30, 120]));
      // return;
      // console.log(gsxarea.features);
      let mygetData = null;
      gsxarea.features.map((item) => {
        let poly1 = turf.polygon(item.geometry.coordinates);
        // arrListData.slice(0, -1);
        console.log(testData.geometry.coordinates);
        let poly2 = turf.polygon(testData.geometry.coordinates);

        let intersection = turf.intersect(
          turf.featureCollection([poly1, poly2])
        );
        console.log(intersection);
        if (intersection != null) {
          mygetData = intersection;
        }
      });

      if (mygetData != null) {
        let latlngs = [];
        mygetData.geometry.coordinates[0].map((item) => {
          latlngs.push([item[1], item[0]]);
        });
        if (!this.chooseType) {
          if (this.suipianLayer != null) {
            this.map.map.removeLayer(this.suipianLayer);
          }
        }
          // this.map.map.removeLayer(this.chooseLayerData);
          // if(!this.chooseType){
          //    this.map.map.removeLayer(this.chooseLayerData);
          // }
           this.chooseLayerData=null
         this.suipianLayer = L.polygon(latlngs, {
          color: `#ff9300`,
          weight: 3,
          fillColor: "#ff9300",
          fillOpacity: 1,
        }).addTo(this.map.map);
         this.suipianLayer.on("click",(e)=>{
          console.log(e);
            this.landNum = this.landNum-1
             this.getPyAreaDatacel()
           this.map.map.removeLayer(e.target);
           this.suipianLayer = e.target
          
           
         })
        // this.suipianLayer = L.polygon(latlngs, {
        //   color: `#ff9300`,
        //   weight: 3,
        //   fillColor: "#ff9300",
        //   fillOpacity: 1,
        // }).addTo(this.map.map);
       
       
        // this.chooseLayerData=null
        this.chooseLayerData = this.suipianLayer;
        if (this.chooseType) {
          this.getPyAreaDatasum();
        } else {
          this.getPyAreaData();
        }
      }
    },
    chooseTypeChange() {
      // this.typechange();
      this.isShowgetSbdDataPop = false;
    },
    checkedCLayerChange() {
      // this.typechange()
      this.areaDataText = 0;
      console.log(this.checkedCLayer.includes("控规图层"));
      console.log(this.checkedCLayer.includes("权属图层"));
      this.typechange();
    },
    typechange() {
      if (this.showkongguilayer != null) {
        this.map.map.removeLayer(this.showkongguilayer);
        this.layerControl.removeLayer(this.showkongguilayer);
      }
      if (this.showquanshuilayer != null) {
        this.map.map.removeLayer(this.showquanshuilayer);
        this.layerControl.removeLayer(this.showquanshuilayer);
      }
      this.choosePyListData = [];
      this.landNum=0
      this.showGuiKongTomap();
    },
    showGuiKongTomap() {
      let canuseguikong = false;
      let canusequanshu = false;
      if (this.layerCantouch == "guikong") {
        canuseguikong = true;
      } else if (this.layerCantouch == "quanshu") {
        canusequanshu = true;
      } else {
        canuseguikong = true;
        // this.chooseType = false;
      }
      let t = this;
      let colorListobj = {
        A6: "#9966CC",
        A2: "#FF7FCC",
        A1: "#FF7FCC",
        A22: " #CC9999",
        A41: " #66CCCC",
        C36: " #66FF99",
        B: " #FF0000 ",
        G2: " #00CC99 ",
        GE: " #00CC33 ",
        B2: " #FF0000 ",
        U9: " #0000CC ",
        G1: " #AEE0CF ",
        R21: " #E0AFCE   ",
        R22: " #E0AFCE   ",
        B12: " #D7D6AC   ",
        U: " #E0AFCE   ",
        U22: "#E0AFCE",
      };
      let indexid = 0;
      this.showkongguilayer = L.geoJSON(areadata, {
        interactive: canuseguikong,
        style: function (feature) {
          // console.log(feature);
          let color = colorListobj[feature.properties.Layer];
          // console.log(color);
          if (color == undefined) {
            if (feature.properties.Layer == 131) {
              // console.log(21212);

              color = "#8EAFD6";
            } else {
              color = "#AEE0CF";
            }
          }
          return {
            color: "white",
            weight: 1,
            fillColor: color,
            fillOpacity: 1,
          };
        },
        onEachFeature: (e, layer) => {
          indexid++;
          let color = colorListobj[e.properties.Layer];
          // console.log(color);
          if (color == undefined) {
            if (e.properties.Layer == 131) {
              // console.log(21212);

              color = "#8EAFD6";
            } else {
              color = "#AEE0CF";
            }
          }
          let laeyerId = "pylayer" + indexid;
          layer.on("click", (el) => {
            // console.log(laeyerId);
            console.log(el);
            t.chosePrintData = [el.latlng.lat, el.latlng.lng];
            if (!t.chooseType) {
              t.chooseLandId = el.sourceTarget._leaflet_id;
              t.openpopInfo()
              t.isShowgetSbdDataPop = true;
            } else {
              t.isShowgetSbdDataPop = false;
            }
            if (!t.isOpenDel) {
              t.isChoosePy = true;
              let isHave = false;
              isHave = t.choosePyListData.find(
                (element) => element.id == laeyerId
              );

              if (t.chooseType) {
                if (t.choosePyListData.length > 0) {
                  let indexele = t.choosePyListData.indexOf(isHave);

                  if (indexele > -1) {
                    // 或者 >= 0
                    t.choosePyListData.splice(indexele, 1);
                    t.landNum=t.landNum-1
                  }
                  // console.log(isHave);

                  if (isHave != undefined) {
                    // console.log("cunzai");
                    t.chooseLayerData = layer;
                    t.getPyAreaDatacel();
                    isHave.layer.setStyle({
                      color: "white",
                      weight: 1,
                      fillColor: color,
                      fillOpacity: 1,
                    });
                  } else {
                    t.chooseLayerData = layer;
                    if (t.layerCantouch == "suipian") {
                      t.getPyAreaDatasuipian();
                    } else {
                      t.getPyAreaDatasum();
                    }
                  }
                } else {
                  t.chooseLayerData = layer;
                  if (t.layerCantouch == "suipian") {
                    t.getPyAreaDatasuipian();
                  } else {
                    t.getPyAreaDatasum();
                  }
                }
                if (t.chooseType && !isHave) {
                   t.landNum=t.landNum+1
                   if(t.layerCantouch!='suipian'){
                      t.choosePyListData.push({
                    id: laeyerId,
                    layer: layer,
                  });
                   }
                
                }
              } else {
                if (t.chooseLayerData != null && t.chooseType == false) {
                  t.chooseLayerData.setStyle({
                    color: "white",
                    weight: 1,
                    fillColor: color,
                    fillOpacity: 1,
                  });
                  t.chooseLayerData = null;
                }

                t.chooseLayerData = layer;
                // console.log(t.layerCantouch);

                if (t.layerCantouch == "suipian") {
                  t.getPyAreaDatasuipian();
                } else {
                  t.getPyAreaData();
                }
              }

              if (!isHave) {
                t.chooseLayerData.setStyle({
                  color: "red",
                  weight: 2,
                  fillColor: "red",
                  fillOpacity: 0.5,
                });
              }
            } else {
              t.map.map.removeLayer(layer);
            }

            // console.log(t.isClip);
          });
        },
      });

      //  console.log([...new Set(colorList)]);

      // console.log(huaguo7);

      this.showquanshuilayer = L.geoJSON(gsxarea, {
        style: {
          color: `#ff9300`,
          weight: 3,
          fillColor: "#ff9300",
          fillOpacity: 0,
        },
        interactive: canusequanshu,
        onEachFeature: (e, layer) => {
          indexid++;
          let color = colorListobj[e.properties.Layer];
          // console.log(color);
          if (color == undefined) {
            if (e.properties.Layer == 131) {
              // console.log(21212);

              color = "#8EAFD6";
            } else {
              color = "#AEE0CF";
            }
          }
          let laeyerId = "pylayer" + indexid;
          layer.on("click", (el) => {
            // console.log(laeyerId);
            console.log(el);
            t.chosePrintData = [el.latlng.lat, el.latlng.lng];
            if (!t.chooseType) {
              t.chooseLandId = el.sourceTarget._leaflet_id;
                  t.openpopInfo()
              t.isShowgetSbdDataPop = true;
            } else {
              t.isShowgetSbdDataPop = false;
            }
            if (!t.isOpenDel) {
              t.isChoosePy = true;
              let isHave = false;
              isHave = t.choosePyListData.find(
                (element) => element.id == laeyerId
              );

              if (t.chooseType) {
                if (t.choosePyListData.length > 0) {
                  let indexele = t.choosePyListData.indexOf(isHave);

                  if (indexele > -1) {
                    // 或者 >= 0
                    t.choosePyListData.splice(indexele, 1);
                     t.landNum=t.landNum-1
                  }
                  // console.log(isHave);

                  if (isHave != undefined) {
                    // console.log("cunzai");
                    t.chooseLayerData = layer;
                    t.getPyAreaDatacel();
                    isHave.layer.setStyle({
                      color: `#ff9300`,
                      weight: 3,
                      fillColor: "#ff9300",
                      fillOpacity: 0,
                    });
                  } else {
                    t.chooseLayerData = layer;

                    t.getPyAreaDatasum();
                  }
                } else {
                  t.chooseLayerData = layer;

                  t.getPyAreaDatasum();
                }
                if (t.chooseType && !isHave) {
                   t.landNum=t.landNum+1
                  t.choosePyListData.push({
                    id: laeyerId,
                    layer: layer,
                  });
                }
              } else {
                if (t.chooseLayerData != null && t.chooseType == false) {
                  t.chooseLayerData.setStyle({
                    color: `#ff9300`,
                    weight: 3,
                    fillColor: "#ff9300",
                    fillOpacity: 0,
                  });
                  t.chooseLayerData = null;
                }

                t.chooseLayerData = layer;
                // console.log(t.layerCantouch);

                t.getPyAreaData();
              }

              if (!isHave) {
                t.chooseLayerData.setStyle({
                  color: "red",
                  weight: 2,
                  fillColor: "red",
                  fillOpacity: 0.5,
                });
              }
            } else {
              t.map.map.removeLayer(layer);
            }

            // console.log(t.isClip);
          });
        },
      });
      if (this.checkedCLayer.includes("控规图层")) {
        this.showkongguilayer.addTo(this.map.map);
        this.layerControl.addOverlay(this.showkongguilayer, "控规图层");
        this.map.map.flyToBounds(this.showkongguilayer.getBounds());
      }
      if (this.checkedCLayer.includes("权属图层")) {
        this.showquanshuilayer.addTo(this.map.map);

        this.layerControl.addOverlay(this.showquanshuilayer, "权属图层");
      }
    },
    fileChange(param) {
      let t = this;
      // console.log(param.file);
      this.$refs.upload.clearFiles();

      const reader = new FileReader();
      const fileData = param.file;
      //读取文件
      reader.readAsArrayBuffer(fileData);

      let that = this;
      reader.onload = function () {
        // 定义geojson数组, 一个shp里会有多个面, 即有多个geometry
        let geojsonArr = [];
        shapefile
          .open(this.result)
          .then((source) => {
            source.read().then(function log(result) {
              if (result.done) {
                //解析完成
                // console.log(geojsonArr);
                t.showShpToMap(geojsonArr);
                //可以在地图绘制展示geojsonArr
                return;
              }

              const json = result.value;
              geojsonArr.push(json);
              // console.log(geojsonArr);

              return source.read().then(log);
            });
          })
          .catch((error) => {
            console.error(error.stack);
            this.$message.error("读取shp文件失败");
          });
      };
    },
    removeTableData(id) {
      // console.log(id);
      let newArr = this.mapLayerList;
      // console.log(newArr);
      let fliterData = newArr.filter((item) => item.code !== id);
      // console.log(fliterData);
      this.mapLayerList = fliterData;
      this.addTableData();
    },
    showShpToMap(data) {
      // console.log(data);
      let shpData = L.geoJSON(data, {
        style: {
          color: "blue",
          weight: 2,
          fillColor: "lightblue",
          fillOpacity: 0.3,
        },
      }).addTo(this.map.map);
      this.map.map.flyToBounds(shpData.getBounds());
    },
    getTbaeData() {
      this.downLoadData(this.ptTableData, "地块属性表");
    },
    downLoadData() {
      const headers = ["类型", "矢量数据"];
      const data = this.ptTableData.map((item) => [item.type, item.geoJson]);
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "数据导出.xlsx");
    },
    closeBufferBox() {
      this.isShowDeffer = false;
    },
    gotoPypostion(data) {
      if (data.type == "Marker") {
        let gsonstr = JSON.parse(data.geoJson);
        // geometry.coordinates
        this.map.map.flyTo(
          [gsonstr.geometry.coordinates[1], gsonstr.geometry.coordinates[0]],
          10
        );
        // console.log();
      } else {
        this.map.map.flyToBounds(data.layer.getBounds());
      }
    },
    addTableData(data) {
      //       this.map.map.eachLayer(function(layer){
      //     layer.bindPopup('Hello');
      // });
      // return
      this.ptTableData = [];
      this.mapLayerList.map((item) => {
        this.ptTableData.push({
          type: item.layer.shape,
          layer: item.layer.layer,
          geoJson: JSON.stringify(item.layer.layer.toGeoJSON()),
        });
      });
    },
    getintersectPydata() {
      this.isOpengetintersect = !this.isOpengetintersect;
      if (this.isOpengetintersect == true) {
        this.$message("请依次选择两个图形");
      }
    },
    changeDelType() {
      this.isOpenDel = !this.isOpenDel;
    },
    getCircleArea(radius, print) {
      var area = Math.PI * radius * radius;
      // console.log(area);
      var myIcon = L.divIcon({
        html: (area / 1000000).toFixed(2) + "km²",
        className: "my-div-icon",
        iconSize: 30,
      });
      if (this.areaMarker != null) {
        this.map.map.removeLayer(this.areaMarker);
      }
      this.areaMarker = L.marker([print.lat, print.lng], {
        icon: myIcon,
      }).addTo(this.map.map);
    },
    showCliopLyer(data) {
      // console.log(this.chooseLayerCode);
      let t = this;
      // console.log(data.features);
      data.features.map((item) => {
        let itemdata = item.geometry.coordinates[0];
        // console.log(item.geometry.coordinates[0]);
        // let mtdata = [];
        let mtdata2 = [];
        for (let i = 0; i < item.geometry.coordinates[0].length; i++) {
          // mtdata.push([itemdata[i][1], itemdata[i][0]]);
          mtdata2.push([itemdata[i][0], itemdata[i][1]]);
        }
        let geojson = turf.polygon([mtdata2]);
        let options = { tolerance: 0.0001, highQuality: true };
        let simplified = turf.simplify(geojson, options); //对裁剪完成的图形进行简化 防止折叠

        console.log(simplified);
        L.geoJSON(simplified, {
          style: {
            color: "#0080FF",
            weight: 2,
            fillColor: "#0080FF",
            fillOpacity: 0.2,
          },
          onEachFeature: (e, layer) => {
            let layerCode = uuid.v1();
            //  t.addTableData(layer)
            t.mapLayerList.push({
              code: layerCode,
              layer: {
                shape: "Polygon",
                layer: layer,
              },
            });
            layer.on("click", (el) => {
              if (!t.isOpenDel) {
                t.isChoosePy = true;
                if (t.chooseLayerData != null) {
                  t.chooseLayerData.setStyle({
                    color: "#0080FF",
                    weight: 2,
                    fillColor: "#0080FF",
                    fillOpacity: 0.2,
                  });
                  t.chooseLayerData = null;
                }

                t.chooseLayerData = layer;
                t.chooseLayerData.setStyle({
                  color: "red",
                  weight: 2,
                  fillColor: "red",
                  fillOpacity: 0.5,
                });
                t.getPyAreaData();
              } else {
                t.map.map.removeLayer(layer);
              }

              // console.log(t.isClip);
            });
            layer.on("remove", () => {
              // console.log('remove');
              t.removeTableData(layerCode);
            });
          },
        }).addTo(this.map.map);
        return;
        // let color='red'
        // if(index==0){
        //   color='red'
        // }else{
        //   color="green"
        // }

        let polygon = L.polygon([mtdata], { color: color }).addTo(this.map.map);
        console.log(polygon.toGeoJSON());

        polygon.on("click", () => {
          //  console.log(el);
          t.isChoosePy = true;
          if (t.chooseLayerData != null) {
            t.chooseLayerData.setStyle({
              color: "#0080FF",
              weight: 2,
              fillColor: "#0080FF",
              fillOpacity: 0.2,
            });
            t.chooseLayerData = null;
          }

          polygon.setStyle({
            color: "red",
            weight: 2,
            fillColor: "red",
            fillOpacity: 0.5,
          });
          t.chooseLayerData = polygon;
          t.getPyAreaData();
        });
        //  L.geoJSON(item, {
        //                  style: {
        //         color: "#0080FF",
        //         weight: 2,
        //         fillColor: "#0080FF",
        //         fillOpacity: 0.2
        //       }
        //           }).addTo(this.map.map)
      });
    },
    getPyAreaDatacel() {
      // console.log(this.chooseLayerData.getLatLngs());
      // console.log(turf.getCoord(this.chooseLayerData));
      let arrList = this.chooseLayerData.getLatLngs()[0];
      console.log(arrList);
      let newarrList = [];
      arrList.map((item) => {
        newarrList.push([item.lng, item.lat]);
      });
      newarrList.push([arrList[0].lng, arrList[0].lat]);
      console.log([newarrList]);
      // return
      var polygon = turf.polygon([newarrList]);

      var area = turf.area(polygon);
      console.log(area);
      let oldareaData = Number(this.areaDataText);
      this.areaDataText = oldareaData - area / 1000000;
    },
    getPyAreaDatasum() {
      // console.log(this.chooseLayerData.getLatLngs());
      // console.log(turf.getCoord(this.chooseLayerData));
      let arrList = this.chooseLayerData.getLatLngs()[0];
      console.log(arrList);
      let newarrList = [];
      arrList.map((item) => {
        newarrList.push([item.lng, item.lat]);
      });
      newarrList.push([arrList[0].lng, arrList[0].lat]);
      console.log([newarrList]);
      // return
      var polygon = turf.polygon([newarrList]);

      var area = turf.area(polygon);
      console.log(area);
      let oldareaData = Number(this.areaDataText);
      this.areaDataText = oldareaData + area / 1000000;
    },
    getPyAreaData() {
      // console.log(this.chooseLayerData.getLatLngs());
      // console.log(turf.getCoord(this.chooseLayerData));
      let arrList = this.chooseLayerData.getLatLngs()[0];
      console.log(arrList);
      let newarrList = [];
      arrList.map((item) => {
        newarrList.push([item.lng, item.lat]);
      });
      newarrList.push([arrList[0].lng, arrList[0].lat]);
      console.log([newarrList]);
      // return
      var polygon = turf.polygon([newarrList]);

      var area = turf.area(polygon);
      console.log(area);
      this.areaDataText = area / 1000000;
    },
    getPyAreaData2() {
      // console.log(this.chooseLayerData.getLatLngs());
      // console.log(turf.getCoord(this.chooseLayerData));
      let arrList = this.chooseLayerData.getLatLngs()[0];
      console.log(arrList);
      let newarrList = [];
      arrList.map((item) => {
        newarrList.push([item.lng, item.lat]);
      });
      newarrList.push([arrList[0].lng, arrList[0].lat]);
      console.log([newarrList]);
      // return
      var polygon = turf.polygon([newarrList]);

      var area = turf.area(polygon);
      console.log(area);
      var center = turf.pointOnFeature(polygon);
      let centerPrint = center.geometry.coordinates;
      // console.log(center.geometry.coordinates
      // );
      // return
      var myIcon = L.divIcon({
        html: (area / 1000000).toFixed(4) + "km²",
        className: "my-div-icon",
        iconSize: 30,
      });
      if (this.areaMarker != null) {
        this.map.map.removeLayer(this.areaMarker);
      }
      this.areaMarker = L.marker([centerPrint[1], centerPrint[0]], {
        icon: myIcon,
      }).addTo(this.map.map);
    },
    clipPy() {
      if (this.isChoosePy) {
        this.isClip = true;
        console.log(this.isClip);

        this.map.map.pm.enableDraw("Line", { finishOn: "dblclick" });
      } else {
        this.$message({
          message: "请先选择图形",
          type: "warning",
        });
        this.isClip = false;
      }

      return;
      console.log(this.chooseLayerData.toGeoJSON(), this.rectangleGeoJson);
      var clippedPolygon = geoUtil.polygonClipByLine(
        this.chooseLayerData.toGeoJSON(),
        this.rectangleGeoJson
      );
      console.log(clippedPolygon);
      return;
      var clipLine = L.polyline([
        [30, 120],
        [20, 130],
      ]);

      // return
    },
    getbufferData() {
      if (!this.isShowDeffer) {
        if (!this.isChoosePy) {
          this.$message({
            message: "请先选择图形",
            type: "warning",
          });
          return;
        }
        if (this.bufferLayer != null) {
          this.map.map.removeLayer(this.bufferLayer);
        }
        this.isShowDeffer = true;
        let newArr = this.rectangleGeoJson.geometry.coordinates;
        let newArr2 = newArr.flat();

        var point = turf.polygon([newArr2]);
        // return
        var buffered = turf.buffer(point, this.bufferNum, { units: "meters" });
        console.log(buffered);
        this.bufferLayer = L.geoJSON(buffered, {
          style: {
            color: "blue",
            weight: 2,
            fillColor: "lightblue",
            fillOpacity: 0.3,
          },
        }).addTo(this.map.map);
      } else {
        this.isShowDeffer = false;
      }

      // console.log(211212);
    },
  },
};
</script>

<style>
.myMapBoxBody {
  height: 100%;
  width: 100%;
  position: relative;
  /* background-color: aquamarine; */
}
.myMapbox {
  height: 100%;
  width: 100%;
  /* width: calc(100% - 400px); */
}
.bufferBox {
  height: 33px;
  width: 33px;
  text-align: center;
  align-items: center;
  position: absolute;
  left: 10px;
  top: 280px;
  z-index: 999;
  background-color: #ffffff;
  border: 2px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.bufferBox img {
  height: 25px;
  width: 25px;
}
.bufferBox2 {
  height: 33px;
  width: 33px;
  text-align: center;
  align-items: center;
  position: absolute;
  left: 10px;
  top: 320px;
  z-index: 999;
  background-color: #ffffff;
  border: 2px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.bufferBox2 img {
  height: 25px;
  width: 25px;
}
.bufferBox3 {
  height: 33px;
  width: 33px;
  text-align: center;
  align-items: center;
  position: absolute;
  left: 10px;
  top: 360px;
  z-index: 999;
  background-color: #ffffff;
  border: 2px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.bufferBox3 img {
  height: 25px;
  width: 25px;
}
.bufferBox4 {
  height: 33px;
  width: 33px;
  text-align: center;
  align-items: center;
  position: absolute;
  left: 10px;
  top: 400px;
  z-index: 999;
  background-color: #ffffff;
  border: 2px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.bufferBox4 img {
  height: 25px;
  width: 25px;
}
.bufferDataChangeBox {
  text-align: center;
  height: 120px;
  width: 150px;
  background-color: white;
  position: absolute;
  z-index: 999;
  right: 480px;
  top: 15px;
  border-radius: 10px;
  border: 2px solid rgba(0, 0, 0, 0.2);
}
.bufferDataTitleBox {
  height: 30px;
  width: 100%;
}
.sildBox {
  /* height: 50px; */
  width: 100%;
  display: flex;
  justify-content: center;
}
.mytableBox {
  height: calc(100vh - 60px);
  width: 400px;
  background-color: #314155;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.textBox {
  width: 170px;
  /* height: 150px; */
  font-size: 8px;
  overflow: hidden;
  /* white-space: nowrap; */
  /* text-overflow: ellipsis; */
}
.expBtnBox {
  height: 100px;
  width: 100%;
  padding: 20px;
  /* background-color: aqua; */
}
.showAreaBox {
  width: 180px;
  height: 100px;
  position: absolute;
  right: 25px;
  top: 100px;
  background-color: white;
  border-radius: 15px;
  z-index: 999;
  text-align: center;
}
.areaDataBox {
  margin-top: 15px;
  font-size: 14px;
  text-align: center;
}
.chooseUseLayerbox {
  /* width:200px; */
  /* height: 50px; */
  position: absolute;
  right: 25px;
  top: 230px;
  z-index: 999;
  background-color: white;
  border-radius: 15px;
  padding: 10px;
  text-align: center;
}
.chooseUseLayerbox2 {
  /* width:200px; */
  /* height: 50px; */
  position: absolute;
  right: 25px;
  top: 330px;
  z-index: 999;
  background-color: white;
  border-radius: 15px;
  padding: 10px;
  text-align: center;
}
.chooseUseLayerbox3 {
  width: 200px;
  /* height: 50px; */
  position: absolute;
  right: 25px;
  top: 450px;
  z-index: 999;
  background-color: white;
  border-radius: 15px;
  padding: 10px;
  text-align: center;
}
.chooseUseLayerbox4 {
  width: 200px;
  /* height: 50px; */
  position: absolute;
  right: 25px;
  top: 600px;
  z-index: 999;
  background-color: white;
  border-radius: 15px;
  padding: 10px;
  text-align: center;
}
.tongjiBtn {
  width: 180px;
}
.getSbdDataPop {
  height: 200px;
  width: 300px;
  position: absolute;
  left: 25px;
  bottom: 50px;
  z-index: 999;
  background-color: white;
  border-radius: 15px;
}
.getSbdDataPopTitle {
  height: 40px;
  width: 100%;
  padding: 0px 10px;
  line-height: 40px;
  border-bottom: 1px solid #989898ff;
}
.closeIconBox {
  font-size: 20px;
  position: absolute;
  top: 0px;
  right: 5px;
}
.getsbdTextBox {
  height: 30px;
  line-height: 30px;
  padding: 0px 10px;
  font-size: 12px;
}
</style>
